'use client'

import React from 'react';
import ReactPaginate from 'react-paginate';

interface Props {
    pageCount: number;
    onPageChange: (selected: number) => void;
    /** Keeps pager UI in sync when page is corrected from outside (filters / clamp). */
    forcePage?: number;
}

const HandlePagination: React.FC<Props> = ({ pageCount, onPageChange, forcePage }) => {
    return (
        <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            pageCount={pageCount}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            onPageChange={(selectedItem) => onPageChange(selectedItem.selected)}
            forcePage={forcePage}
            disableInitialCallback
            containerClassName={'pagination'}
            activeClassName={'active'}
        />
    );
};

export default HandlePagination;
